import { render, staticRenderFns } from "./FeatureSetup.vue?vue&type=template&id=65597019&scoped=true"
import script from "./FeatureSetup.vue?vue&type=script&lang=js"
export * from "./FeatureSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65597019",
  null
  
)

export default component.exports